export const sources = {
	avif: "__VITE_ASSET__hO4dd8ILk$iZF7aFIOUkdg__ 640w, __VITE_ASSET__9kBTUqaINCHDANxrI10WCw__ 960w, __VITE_ASSET__i2ywl_YzKp2MjtOEr7ngzA__ 1280w, __VITE_ASSET__aKo4wVjMjV9S8rY28E5Mvg__ 1600w",
	webp: "__VITE_ASSET__kSHvwCjLFxLpY3FM1MyAsA__ 640w, __VITE_ASSET__7PUm3F_uVf$21BIFLSklvQ__ 960w, __VITE_ASSET__yW_eMvu1QqHghXJHMLbBbg__ 1280w, __VITE_ASSET__OestAvA2SyLT4CG6L76dAw__ 1600w",
	jpeg: "__VITE_ASSET__SH3JcDOvWNcn2WIvxBnLpg__ 640w, __VITE_ASSET__E8wuXQ_AmxPT2QBGX_$9Vw__ 960w, __VITE_ASSET__2ZEzIIM_atdpHcr$6kvj$Q__ 1280w, __VITE_ASSET__nJkgIVJgL11RgZiGUBj6wA__ 1600w"
};
export const img = {
	src: "__VITE_ASSET__nJkgIVJgL11RgZiGUBj6wA__",
	w: 1600,
	h: 900
};
export default {
	sources: sources,
	img: img
};
